import type { LS } from "./data";

export function loc(s: LS, locale: string): string {
  return locale === "tr" ? s.tr : s.en;
}

export function hexLuminance(hex: string): number {
  const clean = hex.replace("#", "").slice(0, 6).padEnd(6, "0");
  const r = parseInt(clean.slice(0, 2), 16);
  const g = parseInt(clean.slice(2, 4), 16);
  const b = parseInt(clean.slice(4, 6), 16);
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

export function assignRoles(colors: string[]) {
  return {
    bg:        colors[0] ?? "#000",
    accent:    colors[1] ?? "#3B7EFF",
    secondary: colors[2] ?? "#333",
    surface:   colors[3] ?? "#fff",
  };
}

/** Sort a palette's colors dark→light so positional roles make sense. */
export function sortPalette(colors: string[]): string[] {
  return [...colors].sort((a, b) => hexLuminance(a) - hexLuminance(b));
}

export function contrastText(hex: string): string {
  return hexLuminance(hex) > 128 ? "#111" : "#fff";
}
